import { PublicClientApplication } from "@azure/msal-browser";

// Default SSO Configuration (for all routes except /itly)
const defaultMsalConfig = {
  auth: {
    clientId: "4fa9648f-c285-4add-91b5-6cdd1e3134f6",
    authority: "https://login.microsoftonline.com/43585219-1e6f-4b26-bebb-1804616c714d",
    redirectUri: "https://vectorhealthhcpsearch.com",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Italy SSO Configuration (for /itly route only)
const italyMsalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ITALY_CLIENT_ID || "YOUR_ITALY_CLIENT_ID_HERE",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ITALY_TENANT_ID || "YOUR_ITALY_TENANT_ID_HERE"}`,
    redirectUri: "https://vectorhealthhcpsearch.com",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Create MSAL instances
export const defaultMsalInstance = new PublicClientApplication(defaultMsalConfig);
export const italyMsalInstance = new PublicClientApplication(italyMsalConfig);

// Initialize both instances
defaultMsalInstance.initialize().catch((error) => {
  console.error("Default MSAL Initialization Error:", error);
});

italyMsalInstance.initialize().catch((error) => {
  console.error("Italy MSAL Initialization Error:", error);
});

// Utility function to determine which MSAL instance to use based on path
export const getMsalInstance = (pathname) => {
  // Use Italy SSO for /itly route
  if (pathname && pathname.startsWith("/itly")) {
    return italyMsalInstance;
  }
  // Use default SSO for all other routes
  return defaultMsalInstance;
};

// Utility function to check if user should have access to the current route
export const hasRouteAccess = (pathname, accounts, msalInstance) => {
  if (!accounts || accounts.length === 0) {
    return false;
  }

  const isItalyRoute = pathname && pathname.startsWith("/itly");
  const isItalyUser = msalInstance === italyMsalInstance;

  // Italy users can only access /itly
  if (isItalyUser && !isItalyRoute) {
    return false;
  }

  // Default users cannot access /itly
  if (!isItalyUser && isItalyRoute) {
    return false;
  }

  return true;
};

// Keep backward compatibility - export default instance
export const msalInstance = defaultMsalInstance;
